import JenisKaryawan from './JenisKaryawan'

export default JenisKaryawan